<template>
  <v-card
    v-if="loading || temoignagesAbonnement.length > 0"
    class="pt-5 background-card"
    rounded="0"
  >
    <BaseLoader v-if="loading" />
    <div
      v-else
      class="d-flex flex-column align-center mb-6"
    >
      <div class="mt-3 mb-3">
        <v-card-title class="titre-h2 secondary--text">
          Nos adhérents en parlent
        </v-card-title>
      </div>
      <div class="d-flex flex-row flex-wrap justify-center">
        <div
          v-for="(temoignage, index) in quatreTemoignagesAuHasard"
          :key="index"
          :class="$vuetify.breakpoint.mobile ? 'card-width-mobile' : 'card-width'"
          class="mx-3 my-4"
        >
          <Temoignage :temoignage="temoignage" />
        </div>
      </div>
      <div
        v-if="!abonnements.culturialAbonne"
        class="d-flex flex-column justify-center mb-12 mt-6"
      >
        <v-tooltip
          v-if="$roles.isUtilisateurAgrial() && !$roles.hasAllWriteAccess()"
          bottom
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <AgrButton
                class="px-8 pt-1"
                large
                disabled
                @click="onClickSouscrireAbonnement"
              >
                <span class="action white--text pb-1">Souscrire à l'abonnement</span>
              </AgrButton>
            </div>
          </template>
          Vous n'avez pas les autorisations
        </v-tooltip>
        <AgrButton
          v-else
          class="px-8 pt-1"
          large
          @click="onClickSouscrireAbonnement"
        >
          <span class="action white--text pb-1">Souscrire à l'abonnement</span>
        </AgrButton>
      </div>
    </div>
    <v-dialog
      v-model="isOpenModalDemandeAbonnement"
      :fullscreen="$vuetify.breakpoint.mobile"
      width="500"
    >
      <DemandeAbonnementModal
        v-if="isOpenModalDemandeAbonnement"
        @close="isOpenModalDemandeAbonnement = false"
      />
    </v-dialog>
  </v-card>
</template>


<script>
import {AgrButton} from '@agrial/ui'
import {mapActions, mapGetters} from 'vuex'
import {clone} from '@/utils/clone'
import Temoignage from '@/views/offre-abonnement/components/temoignage.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import DemandeAbonnementModal from '@/views/offre-abonnement/components/modal/demande-abonnement-modal.vue'

export default {
  name: 'TemoignagesAbonnement',
  components: {DemandeAbonnementModal, BaseLoader, Temoignage, AgrButton},
  props: {

  },
  data () {
    return {
      loading: false,
      erreur: false,
      isOpenModalDemandeAbonnement: false
    }
  },

  computed: {
    ...mapGetters({
      temoignagesAbonnement: 'temoignageAbonnement/temoignagesAbonnement',
      abonnements: 'adherent/abonnements',
    }),

    quatreTemoignagesAuHasard () {
      // mélange au hasard les témoignages
      const temoignagesMelanges = clone(this.temoignagesAbonnement).sort(() => 0.5 - Math.random())

      // prend les 3 premiers
      return temoignagesMelanges.slice(0, 3)
    },
  },

  created () {
    this.loadTemoignagesAbonnement()
  },

  methods: {
    ...mapActions({
      getAllTemoignages : 'temoignageAbonnement/getAllTemoignages',
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
    }),

    loadTemoignagesAbonnement () {
      this.loading = true
      this.erreur = false

      this.getAllTemoignages(true)
        .catch(() => this.erreur = true)
        .finally(() => this.loading = false)
    },

    onClickSouscrireAbonnement () {
      this.isOpenModalDemandeAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('DETAILS_ABONNEMENT')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-width {
  width: 350px;
}

.card-width-mobile {
  width: 85%;
}

.background-card {
 min-width: 104%;
  margin-bottom: -75px;
}

</style>
